"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Switch: function() {
        return _Switch.Switch;
    },
    renderSwitch_unstable: function() {
        return _renderSwitch.renderSwitch_unstable;
    },
    switchClassName: function() {
        return _useSwitchStylesstyles.switchClassName;
    },
    switchClassNames: function() {
        return _useSwitchStylesstyles.switchClassNames;
    },
    useSwitchBase_unstable: function() {
        return _useSwitch.useSwitchBase_unstable;
    },
    useSwitchStyles_unstable: function() {
        return _useSwitchStylesstyles.useSwitchStyles_unstable;
    },
    useSwitch_unstable: function() {
        return _useSwitch.useSwitch_unstable;
    }
});
const _Switch = require("./Switch");
const _renderSwitch = require("./renderSwitch");
const _useSwitch = require("./useSwitch");
const _useSwitchStylesstyles = require("./useSwitchStyles.styles");
